import type { Palette } from '@mui/material'

const TEMPLATE_PALETTE = {} as Partial<Palette>
export default TEMPLATE_PALETTE
